/* eslint semi:0 */
import React from 'react'
import { t, } from '../../../jsCore/providers/i18nProvider/i18nProvider'


const blockName = 'league-selection-component'

function getLeagueNameSelectionOption(leagueName){
  const optionProps = {
    key: leagueName,
    value: leagueName,
    children: leagueName,
    className: `${ blockName }__option`,
  }
  return <option { ...optionProps } />
}

export default function LeagueSelection({
  modifier, leagues: leagueNames,
  currentLeague, onChangeLeagueHandler,
}){
  const containerClassName = modifier ?
    `${ blockName } ${ blockName }--${ modifier }` :
    blockName
  return (
    <div className={ containerClassName }>
      <h4 className={ `${ blockName }__title` }>{ t('homepage.schedule') }</h4>
      <div className={ `${ blockName }__wrapper` }>
        <select
          value={ currentLeague }
          onChange={ onChangeLeagueHandler }
          className={ `${ blockName }__league-selection` }
        >
          { leagueNames.map(getLeagueNameSelectionOption) }
        </select>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/schedule/components/leagueSelection.js